import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/_services/api.service';
import { GlobalService } from 'src/app/_services/global.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { mensaService } from '../gestione-mensa.service';
import * as moment from 'moment';
import { ToolbarSettingsModel } from '@syncfusion/ej2-angular-richtexteditor';

@Component({
  selector: 'app-setup',
  templateUrl: './setup.component.html',
  styleUrls: ['./setup.component.css'],
  providers: [MessageService],
})
export class SetupComponent implements OnInit {
  @ViewChild('maintable') maintable:any;
  clonedSez:any[]=[];
  parametri:any={
    preavviso:2,
    orario_pranzo:null,
    orario_cena:null
  };
  testo:any={
    myappfamily:'',
    myqpp:''
  };

    
  public toolsRTE: ToolbarSettingsModel = {
    type: 'Expand' as ToolbarSettingsModel['type'],
    items: ['Bold', 'Italic', 'Underline', 'OrderedList',
        'UnorderedList']};
    
  struttureList:any[]=[];
  tipopiattiList:any[]=[];
  dataList:any[]=[];
  struttura_id:number=0;
  pageTitle:string='';
  isLoading=true;
  costiDefault:boolean=false;
  listFields:any[]=[];
  listParams:any[]=[];
  
  constructor(
    private apiService: ApiService,
    public globalService : GlobalService,
    private messageService: MessageService,
    private route: ActivatedRoute,
    public router: Router,
    private mensaservice: mensaService,
  ) { }

  ngOnInit(): void {
  
    this.listFields=
    [
    
      {
        field:'struttura',
        type:'field',
        header:'Struttura',
      },
      {
        field:'piatto',
        type:'field',
        header:'Piatto',
      },
      {
        field:'costo',
        type:'currency',
        header:'Prezzo',
      },
      {
        field:'dal_giorno',
        type:'date',
        header:'dal giorno',
      }

    ];

    this.parametri.orario_pranzo = new Date();
    this.parametri.orario_pranzo.setHours(12);
    this.parametri.orario_pranzo.setMinutes(30);

    this.parametri.orario_cena = new Date();
    this.parametri.orario_cena.setHours(19);
    this.parametri.orario_cena.setMinutes(0);

    this.tipopiattiList=this.mensaservice.getTipiPiatti(); 
    this.apiService.get('mensa/getstrutture',{}).subscribe((data)=>{
      this.struttureList=data.Result;
      if(this.globalService.loggedUser.struttura_id){
        this.struttura_id=this.globalService.loggedUser.struttura_id;
       
      } else {
        this.struttura_id=JSON.parse(localStorage.getItem('mensa_struttura_id'));
      
      }
      if(this.struttura_id){ 
        let f=this.struttureList.filter((x)=>x.value==this.struttura_id);
        this.pageTitle=f[0].text;
        localStorage.setItem('mensa_struttura_id',  JSON.stringify(this.struttura_id));
        this.changeStruttura();
      }
      this.isLoading=false;
    });
  
  }

  changeStruttura(event:any=null){
    this.dataList=[];
    this.parametri={
      preavviso:2
    };
    this.parametri.orario_pranzo = new Date();
    this.parametri.orario_pranzo.setHours(12);
    this.parametri.orario_pranzo.setMinutes(30);

    this.parametri.orario_cena = new Date();
    this.parametri.orario_cena.setHours(19);
    this.parametri.orario_cena.setMinutes(0);
    if(event){
      this.struttura_id=event.value;
    }
    
    if(!this.struttura_id){
      return;
    }

    let f=this.struttureList.filter((x)=>x.value==this.struttura_id);
    
    this.pageTitle=f[0].text;
    this.apiService.get('mensa/mensa_get_setup',{struttura_id:this.struttura_id}).subscribe((data:any)=>{
      if(data.testi){
        this.testo.myappfamily=data.testi[0].testo_myfamily;
        this.testo.myapp=data.testi[0].testo_myapp;
      }
     
      if((data.Result.preavviso)&&((data.Result.preavviso.length>0))){
        this.parametri=data.Result.preavviso[0];
      }
      if((data.Result.costi)&&((data.Result.costi.length>0))){
        data.Result.costi.forEach((c)=>{
          this.dataList.push({
            id:c.id,
            costo:c.costo,
            piatto:c.piatto,
            dal_giorno:new Date(c.dal_giorno),
            noEdit:(c.noEdit) ? c.noEdit: false 
          });
        });
     
      }

    });
 
  }

  save(){
    let finalCosti=[];
    this.dataList.forEach((c)=>{
      if((c.dal_giorno!='')&&(c.costo!='')&&(c.piatto!='')){
        finalCosti.push(c);
      }
    })
    if(this.parametri.orario_pranzo && this.parametri.orario_pranzo!=''){
       this.parametri.orario_pranzo=(moment(this.parametri.orario_pranzo)).format('HH:mm');
       if(this.parametri.orario_pranzo=='Invalid date'){
        this.parametri.orario_pranzo=null;
       }
    }
    if(this.parametri.orario_cena && this.parametri.orario_cena!=''){
       this.parametri.orario_cena=(moment(this.parametri.orario_cena)).format('HH:mm');
       if(this.parametri.orario_cena=='Invalid date'){
        this.parametri.orario_cena=null;
       }
    }
 

    let setup:any={
      'testomyapp':this.testo.myapp,
      'testomyappfamily':this.testo.myappfamily,
      'preavviso':this.parametri,
      'costi':finalCosti,
      'struttura_id':this.struttura_id,
      'costiDefault':this.costiDefault
    };
   
    this.apiService.post('mensa/mensa_setup_update',setup).subscribe(data => {
      this.addSingle('success', 'Successo', 'Record aggiornato ');
      window.location.reload();
    });
  }
  

  addSingle(sev: string, sum: string, det: string) {
    this.messageService.add({severity: sev, summary: sum, detail: det});
  }

  onRowEditInit(sez: any) {
    this.clonedSez[sez.id] = { ...sez };
  }
  
  onRowEditSave(record: any) {
    if (record.id!='') {
      delete this.clonedSez[record.id];
    } else {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'campo obbligatorio',
      });
    }
  }
  onRowEditCancel(camera: any, index: number) {
    this.dataList[index] = this.clonedSez[camera.id];
    delete this.dataList[camera.id];
  }


  nuovoCosto(){
    const newS:any = {
      costo: 1.00
    };
 
    this.dataList.push(newS);
   
    //Caution: guard again dataKey here
    this.maintable.editingRowKeys[newS[this.maintable.dataKey]] = true;

  }
  
  getTipo(tipo:any){

    let f=this.tipopiattiList.filter((x:any)=> x.value==tipo);
    if((f)&&(f.length>0)){
      return f[0].label;
    } else {
      return '';
    }
  }


}